// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__vy_aZ","title":"styles_title__hM20c","section":"styles_section__xzOd3","paragraph":"styles_paragraph__QR1cn","link":"styles_link__7WOOd","buttonClass":"styles_buttonClass__pGRsz","icon":"styles_icon__pCeAc","iconRotate":"styles_iconRotate__HYd2J"};
module.exports.__checksum = "e7d58b850d8e"
